import React, { memo, ReactElement } from 'react'
import { Button } from 'antd'
import { Translate } from 'react-localize-redux'
import Buttons from '../form-actions-buttons'
import { FormWrapperProps } from './form-wrapper.interfaces'

const FormWrapper = (props: FormWrapperProps): ReactElement => {
  return (
    <form onSubmit={props.handleSubmit}>
      {props.children}
      {props.onComplete
        ? <div className='form-buttons-wrap'>
          <Button
            id='complete_btn'
            size='large'
            className='default-btn'
            onClick={props.onComplete}
          >
            <Translate id='common.form.buttons.doneBtn'
            />
          </Button>
        </div>
        : <Buttons
          currentStep={props.step}
          lastStep={props.lastPage}
          goBack={props.goBack}
          onCancel={props.onCancel}
          invalid={props.invalid}
          mode={props.mode}
          isLoading={props.isLoading}
          isDisabled={props.isDisabled}
          skipCancel={props.skipCancel}
          submitBtnLabel={props.submitBtnLabel}
          editingDisabled={props.editingDisabled}
          featureEnabled={props.featureEnabled}
        />
      }
    </form>
    )
  }

export default memo(FormWrapper)
